import styled from 'styled-components';

import MQ from '../../attrs/mq';

export const Container = styled.div`
  max-width: 770px;
  text-align: center;
  margin: 0 auto;
`;

export const Title = styled.h2`
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: bold;

  ${MQ.md`
    margin-bottom: 2rem;
    font-size: 2.8rem;
  `}
`;

export const Body = styled.div`
  font-size: 1rem;

  ${MQ.md`
    font-size: 1.2rem;
  `}
`;
